import { lazy, Suspense } from 'react'
import { Loader } from '../../shared'
import { AudiometerFormProps } from './AudiometerForm.model'

const LazyAudiometerForm = lazy(() =>
  import(/*  webpackChunkName: "audiometry" */ './AudiometerForm.component').then(
    ({ AudiometerForm }) => ({ default: AudiometerForm }),
  ),
)

export const AudiometerForm = (props: AudiometerFormProps) => (
  <Suspense fallback={<Loader />}>
    <LazyAudiometerForm {...props} />
  </Suspense>
)
